import { productGroupsApi } from '@texas/api/endpoints/metadata/productGroupsApi';
import { SearchQuery, EntityItem } from '../../../types';
import { randomIdentifier } from '@texas/utils/helpers/commonHelpers';
import { ChatMessageEntityLinkType } from '@texas/api/endpoints/chat/chatApi';

export async function searchProductGroup(
  query: SearchQuery,
): Promise<EntityItem[]> {
  const response = await productGroupsApi.getAll({
    searchTerm: query.query,
    sortBy: '',
    sortDesc: false,
    includeArchived: false,
    vdcSupport: null,
  });

  if (response.hasError) {
    return [];
  }

  return response.data.map((c) => ({
    id: c.id,
    name: c.value,
    type: ChatMessageEntityLinkType.ProductGroup,
    identifier: randomIdentifier(),
  }));
}
